<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2 mt-3" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>

      <b-container style="max-width: 90%; margin: auto;">
        <b-row>
          <b-col md="12" class="mt-4 mb-4">
            <div class="divisor">
              {{ $t('crear_nueva_bodega') }}
            </div>
          </b-col>
        </b-row>

        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombre">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input id="nombre" v-model="form.nombre" required :placeholder="$t('nombre')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="nombreIngles">
                <template v-slot:label>
                  {{ $t('nombre_ingles') }}
                </template>
                <b-form-input id="nombreIngles" v-model="form.nombreIngles"
                  :placeholder="$t('nombre_ingles')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="idPais">
                <template v-slot:label>
                  {{ $t('pais') }} <span class="text-danger">*</span>
                </template>
                <b-form-select id="idPais" v-model="form.idPais" required>
                  <option :value="null" disabled>{{ $t('seleccione_pais') }}</option>
                  <option v-for="option in opcionesPaises" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button type="submit" variant="primary">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import bodegaService from '@/api/bodegaService';
import Swal from 'sweetalert2';

export default {
  name: 'BodegaCrear',
  data() {
    return {
      form: {
        nombre: '',
        nombreIngles: '',
        idPais: null,
      },
      opcionesPaises: [],
    };
  },
  async beforeMount() {
    this.opcionesPaises = await bodegaService.getPaisesOptions();
  },
  methods: {
    submitForm() {
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('revisa_datos'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('crear_bodega'),
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (!result.isConfirmed) {
          Swal.close();
          return;
        }

        try {
          Swal.fire({
            html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                  '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                  '<div><h3 style="color:#006393;">' + this.$t('creando') + '</h3></div>' +
                  '</div>',
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          const response = await bodegaService.create(this.form);

          if (!response || !response.data) {
            Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
            return;
          }

          Swal.fire({
            title: this.$t('creado_correctamente'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          });

          const data = response.data;
          const newId = (data && (data.id || data.ID)) ? (data.id || data.ID) : null;
          if (newId) {
            this.$router.push({ name: 'bodega-detalle', params: { id: newId } });
          } else {
            this.$router.push({ name: 'bodegas' });
          }
        } catch (error) {
          let status = 0;
          if (error && error.response && typeof error.response.status !== 'undefined') {
            status = error.response.status;
          }
          const title = (status === 400) ? this.$t('datos_invalidos') : 'Oops...';
          const icon = (status === 400) ? 'warning' : 'error';
          Swal.fire({
            icon: icon,
            title: title,
            text: 'No se pudo crear la bodega. Revisa los datos e inténtalo nuevamente.',
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.divisor {
  font-size: 16px;
  font-weight: 400;
  color: #fff;
  padding: 15px;
  background: #6172e9;
  border-radius: 10px;
}
</style>
